import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Fetchable, { FetchEventListener } from '@philips-emr/tws-core/lib/component/types/fetchable';
import { isEqualShallow } from '@philips-emr/tws-utils';

class FetchAPI extends ComponentAPI implements Fetchable {

  /** @event */
  @AwesomeEvent
  onBeforeFetch = new FetchEventListener();

  /** @event */
  @AwesomeEvent
  onAfterFetch = new FetchEventListener();

  /** @event */
  @AwesomeEvent
  onAbort = new FetchEventListener();

  getParameters(): object {
    return this.state.parameters;
  }

  setParameters(parameters: object): void {
    if (!isEqualShallow(this.state.parameters, parameters)) {
      this.setState({ parameters });
    }
  }

  setLazy(lazy: boolean): void {
    this.setState({ lazy });
  }

  isLazy(): boolean {
    return this.state.lazy;
  }

  setEndpoint(endpoint: string): void {
    // TODO: validate endpoint
    this.setState({ endpoint });
  }

  getEndpoint(): string {
    return this.state.endpoint;
  }

  abort(): void {
    const abortController = this.state.abortController as AbortController;

    if (abortController) {
      abortController.abort();
      this.onAbort.fire();
    }
  }

  forceFetch(): void {
    this.setState({ accumulate: false, forceFetch: true, page: 0 });
  }

}

export default FetchAPI;
